import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  beforeCreate() {
    if (this.axios && this.$store) {
      this.axios.interceptors.response.use(
        response => {
          if (this.isErrorUnauthorizedAccess(response)) {
            this.$store.commit('auth/accessUnauthorized', null, {root: true})

            return Promise.reject(response)
          }

          this.$store.commit('auth/accessAuthorized', null, {root: true})

          return response
        },
        reason => {
          if (this.isErrorUnauthorizedAccess(reason)) {
            this.$store.commit('auth/accessUnauthorized', null, {root: true})
          }

          return Promise.reject(reason)
        }
      )
    }
  },
  watch: {
    isUnauthorized(val) {
      if (!val) {
          return
      }
      this.alertToGetAuthorization()
    },
    totalFailedAttempts(val) {
      if (!val || val <= 0) {
          return
      }
      this.alertToGetAuthorization()
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isUnauthorized',
      'totalFailedAttempts'
    ])
  },
  methods: {
    alertToGetAuthorization() {
      this.$alertify.confirm(
        'Unauthorized Access',
        "Would you like to go to login page?  All changes you've made will be lost.",
        () => {
          this.$alertify.alert('Unauthorized Access', 'Reloading page...please wait!')
          window.location.reload()
        },
        () => {
          this.$alertify.warning(
            'WARNING:  ' +
              'You are not authorized to access this page.  ' +
              'Any changes you make will be lost.'
          )
        }
      )
    },
    isErrorUnauthorizedAccess(error) {
      return this.isResponseUnauthorizedAccess(error)
        || this.isReasonUnauthorizedAccess(error)
    },
    isResponseUnauthorizedAccess(response) {
      const actualResponse = _.has(response, 'response') ? _.get(response, 'response') : response

      return _.includes([401, 403, 405], _.get(actualResponse, ['status']))
    },
    isReasonUnauthorizedAccess(reason) {
      const actualResponse = _.has(reason, 'response') ? _.get(reason, 'response') : reason

      if (_.includes([401, 403, 405], _.get(actualResponse, ['status']))) {
        return true
      }
      if (500 === _.get(actualResponse, ['status'])
        && 'Internal Server Error' === _.get(actualResponse, ['statusText'])
        && 500 === _.get(actualResponse, ['data', 'status'])
        && 'You are not authorized to access this resource' === _.get(actualResponse, ['data', 'detail'])
      ) {
        return true
      }

      return false
    }
  }
}
